import { useCallback } from 'react';

import { useLocation, useNavigate } from 'react-router-dom';

export function useRedirectToLogin(): () => void {
  const navigate = useNavigate();
  const { pathname, search } = useLocation();

  return useCallback(() => {
    navigate('/login', {
      replace: true,
      state: { nextPathname: pathname, nextSearch: search },
    });
  }, [navigate, pathname, search]);
}
